import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

// base library
import '@/core/lazy_lib/components_use'

// ext library
import './directives/action'
import '@/components/global.less'
import * as func from './func' // 全局函数

Vue.use(VueStorage, config.storageOptions)
Vue.use(func)

process.env.NODE_ENV !== 'production' &&
  console.warn('[antd-pro] NOTICE: Antd use lazy-load.')
